/**
 * The path to drupal.
 */
export const DRUPAL_URL = '/drupal';
export const HOST_URL = 'https://drupal.apike.ca';
